import {LocationDao} from '../../dao';
import {LocationModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_CUSTOMER_CATEGORY_BY_ID';

export async function updateLocation(
    userData: Record<string, string>,
    locationId: number,
    update: Record<string, any>
) {
    try {
        const result = await LocationDao.updateLocationById(userData.userToken, locationId, update);

        const resultParsed = LocationModel.parseLocation(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
